import { NavLink } from "react-router-dom";
import { ROUTER_URL } from "../../constants/routerUrl";
import { connect } from "react-redux";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { IUserInfo } from "../../models/common/IUserProfile";
import { apiConfig } from "../../constants/apiConfig";

const StudentMenu = (props: IUserInfo) => {
  const { user } = props;

  const shouldShowFullMenu = !user?.isFreshman || user?.isCourseStarted;
  const videoTutorialsUrl = apiConfig.freshmanVideoTutorialsUrl;

  return (
    <>
      <ul className="accordion-menu">
        {shouldShowFullMenu ? (
          <>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_DASHBOAD}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/dashboard.svg" alt="" /> Dashboard
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.RESOURCES}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/teacher.svg" alt="" /> Resources
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_COURSES}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/book.svg" alt="" /> Courses
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_GRADES}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/award.svg" alt="" /> Grades
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_ACCOUNTS}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/people.svg" alt="" /> Student
                Accounts
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_ACADEMIC_PROFILE}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/user.svg" alt="" /> Academic
                Profile
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_CAREER_PATH}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/careers.svg" alt="" /> Career Path
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.NOTIFICATION}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/bell.svg" alt="" /> Notifications
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.FEEDBACK}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/feedback.svg" alt="" /> Feedback
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.SETTINGS}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/setting.svg" alt="" /> Settings
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.INSTRUCTIONS}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/help.svg" alt="" /> Help
              </NavLink>
            </li>
          </>
        ) : (
          <>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.STUDENT_DASHBOAD}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/dashboard.svg" alt="" /> Dashboard
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.NOTIFICATION}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/bell.svg" alt="" /> Notifications
              </NavLink>
            </li>
            <li className="menu-item">
              <a
                href={videoTutorialsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="menu-title"
              >
                <img src="/assets/images/icon/video.svg" alt="" /> Video
                Tutorials
              </a>
            </li>
            <li className="menu-item">
              <NavLink
                to={ROUTER_URL.INSTRUCTIONS}
                className={({ isActive }) =>
                  isActive ? "menu-title active" : "menu-title"
                }
              >
                <img src="/assets/images/icon/help.svg" alt="" /> Help
              </NavLink>
            </li>
          </>
        )}
      </ul>
      <div className="poweredby">
        <a
          href="https://www.buduportal.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/budu.png" alt="" />
          Powered by Budu Portal
        </a>
        <p className="version">Version 2.0.0</p>
        <p className="copyrights">
          &copy; 2025 Budu Portal. All rights reserved.
        </p>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentMenu);
